import { TableRow } from '@dtk/ui-components';

export const TableRowBlok = ({ ...props }) => {
  return <TableRow data={props} />;
};
